<template>
  <div>
    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Producer Area"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedProducerAreas"
      :columns="columns"
      :total-rows="totalProducerAreas"
      :get-edit-url="getEditUrl"
    />
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import axios from 'axios';

export default {
  name: 'ProducerAreaTable',
  components: {
    BaseTable
  },
  data() {
    return {
      producerAreas: [],
      totalProducerAreas: 0,
      columns: [
        { name: 'id', align: 'left', label: 'ID', field: 'id', sortable: true },
        { name: 'name', align: 'left', label: 'Name', field: 'name', sortable: true },
        { name: 'add_date', align: 'left', label: 'Add Date', field: 'add_date', sortable: true },
        { name: 'edit_date', align: 'left', label: 'Edit Date', field: 'edit_date', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedProducerAreas() {
      return this.producerAreas.map(area => ({
        ...area,
        add_date: new Date(area.add_date).toLocaleDateString(),
        edit_date: new Date(area.edit_date).toLocaleDateString()
      }));
    }
  },
  created() {
    this.fetchProducerAreas();
  },
  methods: {
    fetchProducerAreas() {
      axios
        .get('/api/v1/producer_area/producer-areas/')
        .then(response => {
          this.producerAreas = response.data;
          this.totalProducerAreas = response.data.length;
        })
        .catch(error => {
          console.error('Error fetching producer areas:', error);
        });
    },
    onAdd() {
      this.$router.push('/producer_areas/add');
    },
    getEditUrl(row) {
      return `/producer_area/edit/${row.id}`;
    }
  },
  watch: {
    producerAreas() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the ProducerAreaTable here */
</style>

